export default __webpack_public_path__ + "static/media/murray_ventris.593e2673.png";